<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("House Keeping Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div> -->

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getHouseKeepingReport()"
            >
              {{ $t("fetch") }}
            </button>
          </div>

          <div
            class="col-lg-6 col-xl-3 align-self-center mt-2 d-flex justify-content-end align-items-center"
            v-if="houseKeepingRecords.length > 0"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->
            <span @click="excelDownload()">
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </span>
            <a
              target="_blank"
              @click="getHouseKeepingReport('Y')"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>

      <div class="table-scroll">
        <table class="swc-report-table" border="1" v-if="houseKeepingRecords.length > 0">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Show NO</th>
            <th>Screen/Theatre</th>
            <th>Created Date & Time</th>
            <th>Movie Name</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Admits</th>
            <th>Capacity</th>
            <th>Show Occupancy%</th>
          </thead>
          <tbody v-if="houseKeepingRecords.length > 0">
            <tr v-for="(item, index) in houseKeepingRecords" :key="index">
              <td class="text-left">
                {{ item.show_no }}
              </td>
              <td class="text-left">{{ item.screen_name }}</td>
              <td class="text-right">{{ item.created_at }}</td>
              <td class="text-left">{{ item.movie_name }}</td>
              <td>{{ item.ss_start_show_time }}</td>
              <td>{{ item.ss_end_show_time }}</td>
              <td class="text-right">{{ item.admits }}</td>
              <td class="text-right">{{ item.seatCount }}</td>
              <td class="text-right">{{ item.occupancy }}</td>
            </tr>
          </tbody>
          <tr class="bg-lightgrey font-weight-bold">
            <td colspan="6" class="text-left">Total</td>
            <td class="text-right">{{ houskeepingTotal.totalAdmits }}</td>
            <td class="text-right">{{ houskeepingTotal.totalCapacity }}</td>
            <td class="text-right">{{ houskeepingTotal.totalOccupancyPercentage }}%</td>
          </tr>
        </table>

        <table class="swc-report-table" border="1" v-if="houseKeepingRecords.length === 0">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Show NO</th>
            <th>Screen/Theatre</th>
            <th>Created Date & Time</th>
            <th>Movie Name</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Admits</th>
            <th>Capacity</th>
            <th>Show Occupancy%</th>
          </thead>
          <tbody>
            <tr>
              <td colspan="12">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      houseKeepingRecords: [],
      houskeepingTotal:{
        totalAdmits: 0,
        totalCapacity: 0,
        totalOccupancyPercentage: 0,
      },
      housekeepingTotalExcel: {
        totalAdmits: 0,
        totalCapacity: 0,
        totalOccupancyPercentage: 0,
      },
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    },
  },
  mounted() {},
  methods: {
    moment,
    excelDownload() {
      let temp_data = [];
      this.houseKeepingRecords.map((x, index) => {
        temp_data.push(x);
      });

      

      let totalRow = {
    show_no: "Total",
    screen_name: "",
    created_at: "",
    movie_name: "",
    ss_start_show_time: "",
    ss_end_show_time: "",
    admits: this.housekeepingTotalExcel.totalAdmits || 0,
    seatCount: this.housekeepingTotalExcel.totalCapacity || 0,
    occupancy: this.housekeepingTotalExcel.totalOccupancyPercentage || 0,
  };

  temp_data.push(totalRow);

      let data = [
        {
          sheet: "House Keeping Report",
          columns: [
            {
              value: "show_no",
              label: "Show No",
            },

            {
              value: "screen_name",
              label: "Screen Name",
            },
            {
              value: "created_at",
              label: "Created date & Time",
            },
            {
              value: "movie_name",
              label: "Movie Name",
            },
            {
              value: "ss_start_show_time",
              label: "Start Time",
            },
            {
              value: "ss_end_show_time",
              label: "End Time",
            },
            {
              value: "admits",
              label: "Admits",
            },
            {
              value: "seatCount",
              label: "Capacity",
            },
            {
              value: "occupancy",
              label: "Show Occupancy%",
            },
          ],
          content: temp_data,
        },
      ];
      let cinemaName = this.dropDown.selectedCinemaName;
      let fromDate = this.fromDate
        ? moment(this.fromDate).format("YYYY-MM-DD")
        : null;
      let toDate = this.toDate
        ? moment(this.toDate).format("YYYY-MM-DD")
        : null;
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      let settings = {
        fileName: `HouseKeepingReport_${cinemaName}_${fromDate}_${toDate}_on${dateTime}`,
      };
      xlsx(data, settings);
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getHouseKeepingReport(isPdf = "N") {
      this.houseKeepingRecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName,
        cinema_address: this.dropDown.selectedCinema.cine_address,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.fromDate).format("YYYY-MM-DD"),
        user_name: this.secureStore.get("USINFO").username,
        isPdf,
      };
      ReportsService.GetHouseKeepingReportV2(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.houseKeepingRecords = data.Records;
            this.houskeepingTotal = data;

            let totalAdmits = 0, totalCapacity = 0, totalOccupancyPercentage = 0;
            data.Records.forEach(record => {
              totalAdmits += record.admits || 0;
              totalCapacity += record.seatCount || 0;
              totalOccupancyPercentage += record.occupancy || 0;
            });

            this.housekeepingTotalExcel = {
              totalAdmits,
              totalCapacity,
              totalOccupancyPercentage: (totalOccupancyPercentage / data.Records.length).toFixed(2),
            };
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 1000);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/houseKeepingReport.vue